<template>
  <v-container fluid class="itemgroup-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/itemgroup/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="primary" outlined class="button-shadow">
                <v-icon class="mr-2">mdi-filter-variant</v-icon>
                Filters
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="itemgroups-table"
              show-select
              single-select
              item-key="_id"
              sort-by="itemgroupname"
              :footer-props="footer"
              :headers="headers"
              :items="itemgroups"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Item Group?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteItemGroup.itemgroupname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteItemGroup)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.itemgroupimage" size="35">
                  <img v-bind:src="item.itemgroupimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.itemgroupname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.itemgroupname="{ item }">
                <a class="primaryConst--text">{{ item.itemgroupname }}</a>
              </template>
              <template v-slot:item.itemgroupemail="{ item }">
                <a class="primaryConst--text">{{ item.itemgroupemail }}</a>
              </template>
              <template v-slot:item.itemgroupid="{ item }">
                {{ item.itemgroupid }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.itemgroupstatus="{ item }">
                <v-chip
                  :color="!item.itemgroupstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.itemgroupstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mock from "./mock"
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'itemgroupList',
  data() {
    return {
      mock,
      config,
      snackbar: null,
      dialog: false,
      deleteItemGroup: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Type', value: 'itemgrouptype' },
        { text: 'Name', value: 'itemgroupname' },
        { text: 'Code', value: 'itemgroupcode' },
        { text: 'Status', value: 'itemgroupstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      itemgroupid: ['admin', 'itemgroup'],
      editedIndex: -1,   
    }
  },

  computed: {
    ...mapState('ItemGroup', ['itemgroups', 'isReceiving', 'isDeleting', 'idToDelete', 'itemgroupsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit itemgroup'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    itemgroupsMessage() {
      this.notification = this.itemgroupsMessage;
      this.addSuccessNotification()
    }
  },
  created () {
    this.getItemGroupsRequest()
    this.addSuccessNotification()
  },

  methods: {
    ...mapActions('ItemGroup', [
      "getItemGroupsRequest",
      "deleteItemGroupRequest",
      "updateItemGroupRequest",
      "createItemGroupRequest"
    ]),

    editItem(item) {
      this.$router.push({ name: 'ItemGroupEdit', params: item })
    },

    deleteItem(item) {
      console.log(item);
      //const pos = this.itemgroups.map(function(itemgroup) { return itemgroup._id; }).indexOf(item._id);
      //this.itemgroups.splice(pos, 1);
      this.deleteItemGroupRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteItemGroup = {
        _id: item._id,
        itemgroupname: item.itemgroupname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        !config.isBackend ?
        Object.assign(this.itemgroups[this.editedIndex], this.editedItem)
        :
        this.updateItemGroupRequest(this.editedItem)
      } else {
        !config.isBackend ?
        this.itemgroups.push(this.editedItem)
        :
        this.createItemGroupRequest(this.editedItem)
      }
      this.close()
    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
